import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PageNotFound as PageNotFoundTemplate } from '@agco-onedigital/ecosystem-lib-web-components';
import { EAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import notFoundMessages from 'messages/pageNotFound';
import { IProps } from './types';

const PageNotFound = ({ errorCode }: IProps) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleReturnTo = () => {
    navigate(EAuthRoutes.DASHBOARD);
  };

  return (
    <PageNotFoundTemplate
      id="page-not-found-cep"
      title={formatMessage(notFoundMessages.pageNotFoundTitle)}
      description={formatMessage(notFoundMessages.pageNotFoundDescription)}
      errorCode={errorCode ?? '404'}
      whatToDo={formatMessage(notFoundMessages.pageNotFoundWhatToDo)}
      whatToDoSteps={[
        { step: formatMessage(notFoundMessages.pageNotFoundTodoStep1) },
        { step: formatMessage(notFoundMessages.pageNotFoundTodoStep2) },
        { step: formatMessage(notFoundMessages.pageNotFoundTodoStep3) },
      ]}
      refreshButtonLabel={formatMessage(notFoundMessages.pageNotFoundRefreshButtonLabel)}
      returnToHomeButtonLabel={formatMessage(notFoundMessages.pageNotFoundReturnToHomeButtonLabel)}
      returnTo={handleReturnTo}
    />
  );
};

export default PageNotFound;
